module.exports = __webpack_public_path__ + "img/108.580c8123.png";